import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

// 登录页：无注册入口，账号由管理员在「账号管理」中添加
const Login: React.FC = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password || loading) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : '登录失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span>快推 AI</span>
          <span className="login-badge">Demo 演示版</span>
        </div>
        <h2>登录账号</h2>
        <form onSubmit={handleSubmit}>
          <div className="login-field">
            <label>用户名</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
              autoFocus
            />
          </div>
          <div className="login-field">
            <label>密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="login-btn" disabled={loading || !username.trim() || !password}>
            {loading ? '登录中...' : '登 录'}
          </button>
        </form>
        <p className="login-hint">本系统无注册入口，账号由管理员在「账号管理」中统一创建；如需账号请联系管理员。</p>
      </div>
    </div>
  );
};

export default Login;
